export default __webpack_public_path__ + "static/media/widget_watchbox_vpmndx1_buy.46f62ffd.mp3";